import { GET_DMA, GET_DMA_SUCCEEDED, GET_DMA_FAILED, USER_UPDATED_ZIP_CODE, USER_UPDATED_ZIP_CODE_ERROR, USER_OPENED_ZIP_CODE_MODAL } from '../constants';
import { getCookie } from '../../utils';
import getBrandConfig from '../../../config/brand';

/**
 * DMA (Dealer Media Area) is derived using the users zip code
 * if an incorrect zipcode is sent in the service will return an error
 * A users location, region and other data can be derived from this.
 */

const brandConfig = getBrandConfig(process.env.BRAND_CHANNEL, process.env.LANG, process.env.SLOT, process.env.VENDOR); // eslint-disable-line
const ZipCodeCookie = brandConfig.cookies.zipCode;

const initialState = {
  loading: false,
  dmaCityName: undefined,
  dmaId: undefined,
  dmaLatitude: undefined,
  dmaLongitude: undefined,
  dmaName: undefined,
  dmaRegion: undefined,
  dmaStateCode: undefined,
  dmaStateName: undefined,
  zipCode: getCookie(ZipCodeCookie),
  zipCodeValidationError: undefined,
  error: null,
  userChangingLocation: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case USER_OPENED_ZIP_CODE_MODAL: {
      return {
        ...state,
        userChangingLocation: true
      }
    }

    case USER_UPDATED_ZIP_CODE: {
      return {
        ...state,
        zipCode: action.zipCode,
        zipCodeValidationError: undefined,
        userChangingLocation: false,
      }
    }

    case USER_UPDATED_ZIP_CODE_ERROR: {
      return {
        ...state,
        zipCodeValidationError: action.errorMsg
      }
    }

    case GET_DMA:
      return {
        ...state,
        loading: true,
      };

    case GET_DMA_SUCCEEDED:
      return {
        ...state,
        ...action.result,
        loading: false,
        error: null
      };

    case GET_DMA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/dma.js
 **/